export default __webpack_public_path__ + "40c34c1e4e91926e4e5eb7eaa53cdebc.png";